import { FC } from "react"
import { Link } from "react-router-dom"
import { CardActions } from "@mui/material"

import { EventDto } from "@shared/events-feed/slice/types"
import { getLinkFromEvent } from "@utils/event.link.utils"

import { Row } from "../../index"
import SimpleSharedDialog from "@components/Dialogs/SimpleSharedDialog"
import InfoLabel from "../components/InfoLabel"
import CardTitle from "../components/CardTitle"
import ParticipantsAvatarRow from "../components/ParticipantsAvatarRow"
import CardDescription from "../components/CardDescription"
import CardBadge from "../components/CardBadge"
import CardDivider from "../components/CardDivider"
import formatDateTime from "../components/formatDateTime"
import addressFormat from "../components/addressFormat"
import WalletIconStyled from "../components/WalletIconStyled"
import FavoritesButton from "../components/FavoritesButton"

import FallbackImg from "../../../assets/svg/profile/FallbackImg.svg"
import CalendarIconCard from "/src/assets/svg/card-icons-pack/calendar-icon.svg?react"
import ClockIconCard from "/src/assets/svg/card-icons-pack/clock-icon.svg?react"
import LocationIconCard from "/src/assets/svg/card-icons-pack/location-icon.svg?react"

import { FeedCardContent, StyledCard, StyledCardMedia } from "../styles/Card"

export type FeedCardProps = {
  eventInfo: EventDto
}
const FeedCard: FC<FeedCardProps> = ({ eventInfo }) => {
  const formatTime = formatDateTime(eventInfo.startTime)

  return (
    <StyledCard>
      <Link to={`fid/${eventInfo.eventId}`}>
        <StyledCardMedia
          image={eventInfo.avatarUrl[0] ?? FallbackImg}
          title={eventInfo.eventName}
        >
          <CardBadge time={eventInfo?.startTime} />
          {!eventInfo.isFree && (
            <div style={{
              position: "absolute",
              bottom: 10,
              left: 10,
              display: "flex",
              alignItems: "center",
              gap: "4px",
              background: "rgba(0,0,0,0.35)",
              borderRadius: "8px",
              padding: "3px 8px 3px 4px"
            }}>
              <WalletIconStyled style={{ position: "static", marginLeft: 0, scale: "1", bottom: 0 }} />
              {(eventInfo.eventPrice || (eventInfo as any).event_price) && (
                <span style={{
                  color: "green",
                  fontSize: "13px",
                  fontWeight: 700,
                  lineHeight: 1,
                  opacity: 0.9,
                  letterSpacing: "0.3px"
                }}>
                  {Math.round((eventInfo.eventPrice || (eventInfo as any).event_price)).toLocaleString("ru-RU")} ₽
                </span>
              )}
            </div>
          )}
          <FavoritesButton id={eventInfo.eventId} isFavorite={eventInfo.favoriteEvent}/>
        </StyledCardMedia>
      </Link>
      <FeedCardContent>
        <Row>
          <Link to={`fid/${eventInfo.eventId}`}>
            <CardTitle title={eventInfo.eventName} />
          </Link>
          <SimpleSharedDialog
            sharedLink={getLinkFromEvent(eventInfo.eventId)}
          />
        </Row>
        <InfoLabel
          text={addressFormat(eventInfo.eventAddress)}
          LeftIcon={LocationIconCard}
        />
        <Row justifyContent="start" gap={14}>
          <InfoLabel text={formatTime?.date} LeftIcon={CalendarIconCard} />
          <InfoLabel text={formatTime?.time} LeftIcon={ClockIconCard} />
        </Row>
        <CardDivider />
        <Link to={`fid/${eventInfo.eventId}`}>
          <CardDescription text={eventInfo.description} />
        </Link>
      </FeedCardContent>
      <CardActions>
        <ParticipantsAvatarRow
          participants={eventInfo.participants}
          maxCount={5}
        />
      </CardActions>
    </StyledCard>
  )
}
export default FeedCard
